import type { CapabilityControlProps } from '../../core/types';
import { resolveFieldMode } from './resolveFieldMode';

/** 只读 / preview 场景下，list 为空时整块隐藏 */
export function shouldHideEmptyListBlock(control: CapabilityControlProps, listFieldKey: string, isEmpty: boolean): boolean {
  if (!isEmpty) return false;
  if (control.hideEmptyList) return true;
  const mode = resolveFieldMode(listFieldKey, control);
  return mode === 'readonly' || control.blockMode === 'preview';
}
